<template>
  <div class="mt-1">
    <div class="text-xs-right"></div>
    <h3>{{ $t('ACCOUNT.ABOUT_ME') }}</h3>
    <v-tabs color="transparent" slider-color="primary">
      <v-tab v-for="lang in langs" :key="lang.key" :ripple="false">{{ lang.key }}</v-tab>
      <v-tab-item touch v-for="lang in langs" :key="lang.key">
        <v-textarea
          v-model="account.about[lang.key]"
          flat
          box
          solo
          :placeholder="lang.aboutPlaceholder"
          rows="3"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
export default {
  props: ["account"],
  data() {
    return {
      langs: [
        {
          key: "fi",
          aboutPlaceholder: `Kuvaile itseäsi taiteilijana, esimerkiksi mistä saat inspiraatiota taiteeseesi. Suosittelemme, että käännät tekstin kaikille Taikon kielille. Näin profiiisi löytyy paremmin hakukoneiden, kuten Googlen, kautta. Vaihda kieltä kääntääksesi tekstin.`,
        },
        {
          key: "se",
          aboutPlaceholder: `Beskriv dig själv som konstnär, exempelvis vad som inspirerar dig i din konst. Vi rekommenderar, att du översätter texten till Taikos alla tre språk. På så sätt hittar sökmotorer, så som Google, din profil bättre. Byt språk för att översätta texten.`,
        },
        {
          key: "en",
          aboutPlaceholder: `Describe yourself as an artist, for example what inspires you in your art. We recommend that you provide the description in all three languages. This way, your profile can be better found through search engines such as Google. To translate the text, switch to another language..`,
          education: {
            title: "Education",
            placeholder:
              "Fill in your education with focus on artistic education.",
          },
        },
      ],
    };
  },
};
</script>
